module.exports = __webpack_public_path__ + "static/img8-67a9925e2312a0b7212a58089cab04eb.jpg";